<template>
    <div class="slider-inner" style="width: 350px;">
        <div class="slider-header">
            <div class="header-action">
                <Button type="text" size="mini" @click="routeIndent">Cancel</Button>
                <Button type="primary" size="mini" @click="updateIndentDetails">Save</Button>
            </div>
        </div>
        <div class="slider-body">
            <ul class="drawer-list list-flex">
            <li>
                <label>Delivery Number</label>
                <div class="list-content" >
                <Input placeholder="Enter Delivery Number" size="xsmall" :readonly="true" v-model="updateIndent.deliveryNumber" class="form-control"></Input>
                </div>
            </li>
            <li>
              <label>Ship to</label>
              <div class="list-content">
              <Input placeholder="Enter Ship To" size="xsmall" v-model="updateIndent.customer" class="form-control"></Input>
              </div>
            </li>
            <li>
                <label>Address</label>
                <div class="list-content">
                <Input placeholder="Enter Address" size="xsmall" v-model="updateIndent.address" class="form-control"></Input>
                </div>
            </li>
            <li class="mb-5">
                <label>Payment Terms</label>
                <div class="list-content">
                <Select
                    v-model="updateIndent.payment_terms"
                    align="right"
                    size="mini"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark">
                  <Option
                    v-for="item in paymentTerms"
                    :key="item.id"
                    :label="item.name"
                    :value="item.key">
                  </Option>
                </Select>
                </div>
            </li>
            <li class="mb-5">
                <label>Inco Terms</label>
                <div class="list-content">
                <Select
                    v-model="updateIndent.terms"
                    align="right"
                    size="mini"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark">
                    <Option
                    v-for="item in terms"
                    :key="item.id"
                    :label="item.name"
                    :value="item.key">
                    </Option>
                </Select>
                </div>
            </li>
            <li class="mb-5">
                <label>Freight Terms</label>
                <div class="list-content">
                <Select
                    v-model="updateIndent.freight_terms"
                    align="right"
                    size="mini"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark">
                    <Option
                    v-for="item in freightTerms"
                    :key="item.id"
                    :label="item.name"
                    :value="item.key">
                    </Option>
                </Select>
                </div>
            </li>
            <li>
                <label>Related Party</label>
                <div class="list-content">
                <Input placeholder="Enter Related Party" size="xsmall" v-model="updateIndent.related_party" class="form-control"></Input>
                </div>
            </li>
            <li class="mb-5">
                <label>Ship method</label>
                <div class="list-content">
                <Select
                    v-model="updateIndent.ship_pack_method"
                    align="right"
                    size="mini"
                    filterable
                    @input="changeShipMenthod"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark">
                    <Option
                    v-for="item in shipPackCode"
                    :key="item.code"
                    :label="item.description"
                    :value="item.code">
                    </Option>
                </Select>
                </div>
            </li>
            <li class="mb-5">
                <label>Carrier</label>
                <div class="list-content">
                <Select
                    v-model="updateIndent.carrier"
                    align="right"
                    size="mini"
                    popper-class="select-dark-dropdown text-right"
                    class="select-default select-dark">
                    <Option
                    v-for="item in carriersList"
                    :key="item.code"
                    :label="item.serivce"
                    :value="item.description">
                    </Option>
                </Select>
                </div>
            </li>
            </ul>
        </div>


        <!-- <div class="slider-footer footer-dark">
            <div class="flex-container">
                <div class="flex-item ml-auto">
                <span class="number text-green">02</span>
                Total Cartons
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import { terms, paymentTerms, freightTerms } from '../../constants/order';

export default {
  data() {
    return {
      updateIndent: {
        deliveryNumber: null,
        customer: null,
        address: null,
        carrier: null,
        ship_pack_method: null,
        terms: null,
        payment_terms: null,
        freight_terms: null,
        related_party: null,
        is_domestic: false,
      },
      carriersList: [],
      terms,
      paymentTerms,
      freightTerms,
      destinationData: {},
    };
  },
  props: {
    indent: {
      Type: Object,
      default: () => ({}),
    },
    shipPackCode: {
      Type: Array,
      default: () => ([]),
    },
  },
  computed: {
    deliveryNumber() {
      const deliveryNumbers = Object.keys(this.indent.package_details);
      return deliveryNumbers[0];
    },
  },
  async created() {
    if (this.indent) {
      const deliveryNumbers = Object.keys(this.indent.package_details);
      this.updateIndent.deliveryNumber = deliveryNumbers[0];
      this.destinationData = this.indent.destinations[0];
      if (this.destinationData && this.destinationData.details) {
        this.updateIndent.customer = this.destinationData.details.customer;
        this.updateIndent.address = this.destinationData.details.address;
      }
      this.updateIndent.payment_terms = this.indent.payment_terms;
      this.updateIndent.freight_terms = this.indent.freight_terms;
      this.updateIndent.related_party = this.indent.related_party;
      this.updateIndent.carrier = this.indent.transporter && this.indent.transporter.name;
      this.updateIndent.terms = this.indent.terms;
      this.updateIndent.is_domestic = this.indent.is_domestic;
      this.updateIndent.ship_pack_method = this.indent.ship_pack_code;
      this.updateIndent = { ...this.updateIndent };
    }
  },
  methods: {
    async updateIndentDetails() {
      const indentData = {
        terms: this.updateIndent.terms,
        ship_pack_method: this.updateIndent.ship_pack_method,
        destination_id: this.destinationData.location_id,
        address: this.updateIndent.address,
        customer: this.updateIndent.customer,
        carrier: this.updateIndent.carrier,
        payment_terms: this.updateIndent.payment_terms,
        freight_terms: this.updateIndent.freight_terms,
        related_party: this.updateIndent.related_party,
      };
      const orderId = this.$route.params && this.$route.params.orderId;
      const resp = await this.$store.dispatch('indentV2/updateHachIndent', {
        id: orderId,
        data: indentData,
      });
      if (resp.error) {
        this.$errorMessage({
          message: resp.error,
        });
      } else {
        this.$successMessage({
          message: `Indent ${resp} Updated`,
        });
        this.$router.push({ name: 'OutboundIndents' });
      }
    },
    routeIndent() {
      this.$router.push({ name: 'OutboundIndents' });
    },
    changeShipMenthod(value) {
      this.carriersList = [];
      this.updateIndent.carrier = null;
      const shipMethod = this.shipPackCode.find(_obj => _obj.code == value);
      if (shipMethod) {
        if (this.updateIndent.is_domestic && shipMethod.domestic_carriers
        && shipMethod.domestic_carriers.length) {
          this.carriersList = shipMethod.domestic_carriers;
        } else if (shipMethod.international_carriers && shipMethod.international_carriers.length) {
          this.carriersList = shipMethod.international_carriers;
        } else {
          this.$errorMessage({
            message: 'No Domestic Carriers for this ship pack Method',
          });
        }
      }
    },
  },
};
</script>
